import DataTable from "datatables.net-react";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { AutoSquareOffLogServices } from "../../services/AutoSquareOffLogServices";
import * as BullCache from "../../util/BullCache";

function Autosquareofflog(){

  const [Client, setclient] = useState([]);


  var user = BullCache.getFromCache("user");
  useEffect(() => {
   
    AutoSquareOffLogServices.getusers({ 'adminId': user.adminId }).then(res => {

      if (res.code === 1) {

        if (res.data.userList.length > 0) {
          setclient(res.data.userList);
        }
      }


    });

  }, []);



    return(
        <div className="container-fluid">    
        <Card className="mt-2">
          <Card.Body>
              <Row>
                
                <Col className="mt-1">
                    <input type="date" name="bday" />
                </Col>

                <Col className="mt-1">
                            <Form.Select aria-label="Default select example" size='sm' className='bg-light text-black fss-05'>
                            {Client.map((item) => (
                  <option key={item.adminId} value={item.userName}>{item.firstName + ' (' + (item.userName) + ')'}
                  </option>

                ))}

                            </Form.Select>
                </Col>

                <Col className="mt-1">
                   <Button variant="secondary" size="sm" className="w-auto">
                      SEARCH
                   </Button>
                </Col>

                <Col></Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>

              </Row>
          </Card.Body>
        </Card>

        <Card className="mt-2">
          <Card.Body>
          <div className="table-responsive">
              <DataTable className=' striped bordered'>
                      <thead>
                        <tr>
                          <th className='bg-secondary' style={{fontSize:12}}>CLIENT</th>
                          <th className='bg-secondary' style={{fontSize:12}}>MTM</th>
                          <th className='bg-secondary' style={{fontSize:12}}>TIME</th>
                          </tr>
                      </thead>
                     
                    </DataTable>
                    </div>

                   </Card.Body>
        </Card>
   </div>
    )
}
export default Autosquareofflog;